module.exports = __webpack_public_path__ + "static/media/alejandro-cominotti.f6200dee.jpg";